import React, { useState } from 'react';
import {
  TELEMEDICINE_CONSENT_VERSION,
  allConsentClausesAccepted,
  createEmptyConsentChecks,
  telemedicineConsentClauses,
} from '../clinical/telemedicineConsent';

const TelemedicineConsentModal = ({ appointment, patient, onAccept, onCancel, isSaving = false, error = '' }) => {
  const [checks, setChecks] = useState(createEmptyConsentChecks);
  const canAccept = allConsentClausesAccepted(checks);

  return (
    <div className="consent-overlay" role="dialog" aria-modal="true">
      <div className="consent-modal">
        <div className="consent-header">
          <div>
            <h2>Consentimiento informado digital</h2>
            <p>Telemedicina · Version {TELEMEDICINE_CONSENT_VERSION}</p>
          </div>
          <span className="consent-status">Requerido</span>
        </div>

        <div className="consent-summary">
          <p><strong>Paciente:</strong> {patient?.name || appointment?.patient?.name || 'Paciente'}</p>
          <p><strong>Profesional:</strong> {appointment?.doctor?.name || 'Medico asignado'}</p>
          <p><strong>Cita:</strong> {appointment ? new Date(appointment.datetime).toLocaleString('es-ES') : 'Consulta inmediata'}</p>
          <p><strong>Motivo:</strong> {appointment?.reason || 'Atencion por telemedicina'}</p>
        </div>

        <div className="consent-clauses">
          {telemedicineConsentClauses.map((clause) => (
            <label key={clause.id} className="consent-clause">
              <input
                type="checkbox"
                checked={checks[clause.id]}
                onChange={(event) => setChecks((current) => ({
                  ...current,
                  [clause.id]: event.target.checked,
                }))}
              />
              <span>
                <strong>{clause.title}</strong>
                {clause.text}
              </span>
            </label>
          ))}
        </div>

        <div className="consent-note">
          Al aceptar, el sistema guardara fecha, hora, usuario, cita, version del consentimiento, estado de aceptacion e IP si el servidor puede identificarla.
        </div>

        {error && <div className="consent-error">{error}</div>}

        <div className="consent-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={isSaving}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-success"
            disabled={!canAccept || isSaving}
            onClick={() => onAccept({ checks, version: TELEMEDICINE_CONSENT_VERSION })}
          >
            {isSaving ? 'Guardando...' : 'Aceptar y entrar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TelemedicineConsentModal;
